import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from 'primereact/card';
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from "primereact/multiselect";
import { Toast } from "primereact/toast";

import Menu from "../components/Menu";

import api from "../services/api";

export default function LancamentoParada() {
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [observacao, setObservacao] = useState('');
    const [multiple, setMultiple] = useState(false);
    const [selected, setSelected] = useState(null);
    const [tipos, setTipos] = useState([]);
    const [tear, setTear] = useState('');
    const [tempo, setTempo] = useState('');
    const [turma, setTurma] = useState('');
    const [options, setOptions] = useState([]);
    const [options1, setOptions1] = useState([]);

    const [lastInserted, setLastInserted] = useState([]);
    const [lastVisible, setLastVisible] = useState(false);

    const toast = useRef(null);

    const handleSubmit = () => {
        if (date === null || tear === '' || tempo === '' || selected === null || turma === '') {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Preencha todos os campos antes de prosseguir'
            });
            return;
        }
        setLoading(true);
        let formated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        api.post('cadastros/tear-parado/store', {
            "parada_id": selected.id,
            "data": formated,
            "tear": multiple === true ? tear : [tear],
            "tempo": tempo,
            "turma_id": turma,
            "observacao": observacao
        }).then((response) => {
            setObservacao('');
            setTear('');
            setTempo('');

            api.get('cadastros/tear-parado').then((response) => {
                setLastInserted(response.data.registro);
            }).catch((error) => {
                toast.current.show({
                    summary: 'Ocorreu um Erro',
                    severity: 'error',
                    detail: error.response.data.message
                });
            });

            setLoading(false);

            if (multiple === true) {
                confirmDialog({
                    header: 'Resumo',
                    message: () => (
                        <div>
                            <h4>{response.data.message}</h4>
                            <ul>
                                {response.data.errors.map((element, index) => (
                                    <li key={`message${index}`}>{element.message}</li>
                                ))}
                            </ul>
                        </div>
                    ),
                    acceptLabel: 'Ok'
                });
            } else {
                toast.current.show({
                    summary: 'Concluído',
                    severity: 'success',
                    detail: response.data.message
                });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    useEffect(() => {
        setLoading(true);
        api.get('cadastros/tear-parado').then((response) => {
            setLoading(false);
            setTipos(response.data.tipos);

            const { teares } = response.data;

            let options = [];
            for (let i = 1; i <= teares; i++) {
                options.push({
                    'label': `T${i}`, value: i
                });
            }
            setOptions1(options);
            setLastInserted(response.data.registro);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });

        api.get('cadastros/turmas').then((response) => {
            setOptions(response.data);
        }).catch((error) => {
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, []);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card header={() => (
                <>
                    <div className="p-d-flex p-jc-between p-ai-start">
                        <h1 className="p-m-2">Paradas</h1>
                        <div>
                            <Button
                                className="p-button-primary p-m-2"
                                icon="pi pi-history"
                                onClick={() => setLastVisible(!lastVisible)}
                                title="Clique para ver o histórico"
                            />
                            <Button
                                className="p-button-warning p-m-2"
                                onClick={() => {
                                    if (multiple === true) {
                                        setMultiple(false);
                                    } else {
                                        setMultiple(true);
                                    }
                                    setTear('');
                                }}
                                label={multiple === true ? 'Lançar 1' : 'Lançar 2+'}
                            />
                            <Button className="p-button-success p-m-2" icon="pi pi-check" loading={loading} onClick={handleSubmit} label="Salvar" />
                        </div>
                    </div>
                    {lastVisible && (
                        <DataTable
                            className="p-m-1"
                            size="small"
                            value={lastInserted}
                        >
                            <Column header="ID" field="id" />
                            <Column header="Tear" field="tear" />
                            <Column header="Turma" field="turma" />
                            <Column header="Tempo" field="tempo" />
                            <Column header="Parada" field="parada" />
                            <Column header="Data" field="data" />
                        </DataTable>
                    )}
                </>
            )} className="p-m-3">
                <div className="p-grid">
                    <div className="p-d-flex p-flex-row" style={{ width: '100%' }}>
                        <div className="p-col p-md-8 p-d-flex p-flex-column">
                            <div className="p-d-flex p-flex-row">
                                {tipos.length > 1 ? tipos.map((element) => (
                                    <div key={element.nome} className="p-col">
                                        <h2>{element.nome}</h2>
                                        <DataTable
                                            value={element.paradas}
                                            selection={selected}
                                            selectionMode="single"
                                            onSelectionChange={(e) => setSelected(e.value)}
                                        >
                                            <Column sortable header="Nome" field="nome" />
                                        </DataTable>
                                    </div>
                                )) : null}
                            </div>
                            <div className="p-field">
                                <span><strong>Observação: </strong></span>
                                <InputText
                                    onChange={e => setObservacao(e.target.value)}
                                    placeholder="Preencha para fazer uma observação em relação à parada. Não obrigatório..."
                                    style={{ width: '100%' }}
                                    value={observacao}
                                />
                            </div>
                        </div>
                        <div className="p-col p-md-4">
                            <div className="p-fluid">
                                <div className="p-field">
                                    <span><strong>Turma: </strong></span>
                                    <Dropdown
                                        onChange={e => setTurma(e.value)}
                                        optionLabel="nome"
                                        optionValue="id"
                                        options={options}
                                        placeholder="Escolha uma Turma"
                                        value={turma}
                                    />
                                </div>
                                <div className="p-field">
                                    <span><strong>Data: </strong></span>
                                    <Calendar
                                        className="p-mt-2 p-mb-2"
                                        dateFormat="dd/mm/yy"
                                        onChange={e => setDate(e.value)}
                                        mask="99/99/9999"
                                        placeholder="Escolha uma data (Obrigatório)"
                                        value={date}
                                    />
                                </div>
                                {multiple ? (
                                    <Card className="p-field" title="Tear">
                                        <MultiSelect
                                            selectedItemsLabel="{0} teares selecionados"
                                            maxSelectedLabels={12}
                                            onChange={e => setTear(e.value)}
                                            options={options1}
                                            placeholder="Escolha os teares"
                                            value={tear}
                                        />
                                    </Card>
                                ) : (
                                    <Card className="p-field" title="Tear">
                                        <InputText
                                            onChange={e => {
                                                if ((parseInt(e.target.value) && e.target.value.length < 3) || e.target.value === '') {
                                                    setTear(e.target.value)
                                                }
                                            }}
                                            style={{ width: '100%', height: 150, fontSize: 150 }}
                                            value={tear}
                                        />
                                    </Card>
                                )}
                                <Card className="p-field" title="Tempo">
                                    <InputText
                                        onChange={e => {
                                            if ((parseInt(e.target.value) && e.target.value.length < 4) || e.target.value === '') {
                                                setTempo(e.target.value)
                                            }
                                        }}
                                        style={{ width: '100%', height: 150, fontSize: 150 }}
                                        value={tempo}
                                    />
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </Card >
        </div >
    )
}